import React from "react";
import { Helmet } from "react-helmet";

export const WindowTitleComponent = (props) => {
  const title = (props.title ? props.title + " | " : "") + "DesdApp";

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default WindowTitleComponent;
